import { createContext } from 'react'
import _ from 'lodash'
import APIPlugin from './apiPlugin'
import { Capacitor, PluginListenerHandle } from '@capacitor/core'
import { NativePluginEventListenerRemover, NativePluginEventListenerHandler, NativePluginEventName } from '@fusion-advantage/backcompat'

interface EventListener {
	name: NativePluginEventName
	handler: NativePluginEventListenerHandler
}

class PluginContextValue {
	private pluginListenerHandles: PluginListenerHandle[] = []
	private nextCtxListenerId = 0
	private ctxListenersById: Map<number, EventListener> = new Map<number, EventListener>()

	private runCtxListeners(name: NativePluginEventName, data: any) {
		console.info(`[PluginContext runListeners] request to run ctxListeners for ${name}`)
		this.ctxListenersById.forEach((listener, id) => {
			if(listener.name === name) {
				console.info(`[PluginContext runListeners] running ctxListener id ${id} for ${name}`, data)
				listener.handler(data)
			}
		})
	}

	constructor() {
		if(Capacitor.isNativePlatform()) {
			this.init()
		}
	}

	private async init() {
		console.info(`[PluginContext] add pluginListener for ${ NativePluginEventName.ReceiveBarcode}`)
		this.pluginListenerHandles.push(
			await APIPlugin.addListener(NativePluginEventName.ReceiveBarcode, (data: any) => this.runCtxListeners(NativePluginEventName.ReceiveBarcode, data))
		)
		console.info(`[PluginContext] add pluginListener for ${NativePluginEventName.ReceiveSelectedProducts}`)
		this.pluginListenerHandles.push(
			await APIPlugin.addListener(NativePluginEventName.ReceiveSelectedProducts, (data: any) => this.runCtxListeners(NativePluginEventName.ReceiveSelectedProducts, data))
		)
	}

	addCtxListener(name: NativePluginEventName, handler: NativePluginEventListenerHandler): NativePluginEventListenerRemover {
		const id = this.nextCtxListenerId++
		console.info(`[PluginContext] add ctxListener ${id} for ${name}`)
		this.ctxListenersById.set(id, { name, handler })
		return () => {
			console.info(`[PluginContext] remove ctxListener ${id} for ${name}`)
			this.ctxListenersById.delete(id)
		}
	}

	destroy() {
		console.info(`[PluginContext] removing ${this.pluginListenerHandles.length} pluginListeners`)
		this.pluginListenerHandles.forEach(handle => handle.remove())
	}
}

const defaultValue = new PluginContextValue()
const PluginContext = createContext<PluginContextValue>(defaultValue)

export default PluginContext
